import React from 'react';
import accessFactory from '@/access';
import { useAuth } from '@/utils/hooks/Authentication';

export type AccessInstance = ReturnType<typeof accessFactory>;

export const AccessContext = React.createContext<AccessInstance>(accessFactory(null));

function Provider(props: React.PropsWithChildren) {
  const { user } = useAuth();
  const access = React.useMemo(() => accessFactory(user), [user]);

  return <AccessContext.Provider value={access}>{props.children}</AccessContext.Provider>;
}

export function AccessProvider({ children }: React.PropsWithChildren) {
  return <Provider>{children}</Provider>;
}
